module.exports = __webpack_public_path__ + "static/img/hdmd.cbb2109a.png";